import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
// import createHistory from 'history/createHistory';
import thunk from 'redux-thunk';
// import queryString from 'querystring';

import appReducer from '_redux/reducers';

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable no-underscore-dangle */

// const history = createHistory({
//   basename: '',
//   hashType: 'hashbang',
// });

// const { reducer: locationReducer, middleware: routerMiddleware, enhancer: routerEnhancer } = connectRoutes(history, routes, { querySerializer: queryString });

const rootReducer = combineReducers({ app: appReducer });

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
